import Gallery from "./screens/Gallery"
import Location from "./screens/Location"
import Specification from "./screens/Specification"
import AboutUs from "./screens/AboutUs"
// import Film from "./screens/Film"
import Favourites from "./screens/Favourites"
import Overview from "./screens/Overview"
import SetVis from "./components/ApartmentFinder/Components/SetVis"
export const primaryRoutes = [
  {
    path: "/location",
    component: Location
  },
  {
    path: "/overview",
    component: Overview
  },
  {
    path: "/explore",
    component: SetVis
  },
  {
    path: "/specification",
    component: Specification
  },
  {
    path: "/gallery",
    component: Gallery
  },
  {
    path: "/favourites",
    component: Favourites
  },
  // {
  //   name: "Film",
  //   path: "/film",
  //   component: Film
  // },
  {
    name: "About Us",
    path: "/aboutus",
    component: AboutUs
  }
]

export const AboutPath = "/aboutus"

export const home = primaryRoutes[1]
